import React, { useEffect, useState } from 'react';
import {
    FooterOrigination, HeaderOrigination, Sticky,
} from '@honeycomb-npm/honeycomb-react';

import { HeaderMain, Wrapper } from './Wrapper';
import { useAppSelector } from '../../stories/hooks';
import { ApplicationDataContent } from '../../app/navigation/types';
import { selectApplicationContent } from '../../app/netBank/netBankSelectors';
import { DynamicHeaderWrapper } from '../DynamicHeader/DynamicHeader.styled';
import DynamicHeader from '../DynamicHeader';

type Props = {
    children: React.ReactNode;
    isCloseEnabled?: boolean;
    onClickCloseButton?: () => void;
    hideFurniture?: boolean;
    isHidden?: boolean;
    id?: string;
    headerMain?: string;
    headerContent?: string;
};

type Foot = {
    content: string,
}

export const DefaultFoot: Foot = {
    content: '©2024 Commonwealth Bank of Australia ABN 48 123 123 124 AFSL and Australian credit licence 234945',
};

const Origination = ({
    children,
    onClickCloseButton,
    isCloseEnabled,
    hideFurniture,
    isHidden,
    id = 'origination-header-close-button',
    headerMain,
    headerContent,
}: Props) => {
    const [footer, setFooter] = useState(DefaultFoot);

    const applicationContent: string = useAppSelector(selectApplicationContent);

    useEffect(() => {
        if (applicationContent) {
            const parsedContent: ApplicationDataContent = JSON.parse(applicationContent) as ApplicationDataContent;

            if (parsedContent.footer) {
                setFooter(parsedContent.footer);
            }
        }
    }, []);

    return (
        <Wrapper
            className="honeycomb honeycomb-utility"
            isHidden={isHidden}
        >
            {!hideFurniture && (
                <Sticky>
                    <HeaderOrigination
                        closeText="Close"
                        hideClose={!isCloseEnabled}
                        onClick={onClickCloseButton}
                        buttonAttributes={{
                            id,
                            'data-testid': id,
                        }}
                    >
                        <div className="p-0 pl-2">
                            {headerMain && <HeaderMain>{headerMain}</HeaderMain>}
                            <DynamicHeaderWrapper>
                                {headerContent ? (
                                    <div>{headerContent}</div>
                                ) : (
                                    <DynamicHeader />
                                )}
                            </DynamicHeaderWrapper>
                        </div>
                    </HeaderOrigination>
                </Sticky>
            )}
            {children}

            {!hideFurniture && (
                <FooterOrigination fluid={false}>{footer && <p>{footer.content}</p>}</FooterOrigination>
            )}
        </Wrapper>
    );
};

export default Origination;
